export const commandComments = {
  'workbench.action.exitZenMode': '禅モードを終了させる',
  closeReferenceSearchEditor: '検索窓を閉じる',
  cancelSelection: '選択状態を解除',
  cursorBottom: '最下部に移動',
  cursorBottomSelect: '現在位置から最下部までを選択',
  cursorColumnSelectDown: '矩形選択で下に選択位置を伸ばす',
  cursorColumnSelectLeft: '矩形選択で左に選択位置を伸ばす',
  cursorColumnSelectPageDown: '最後の行まで一気に矩形選択',
  cursorColumnSelectPageUp: '最初の行まで一気に矩形選択',
  cursorColumnSelectRight: '矩形選択で右に選択位置を伸ばす',
  cursorColumnSelectUp: '矩形選択で上に選択位置を伸ばす',
  cursorDown: '下に移動',
  cursorDownSelect: '下に選択範囲を広げる',
  cursorEnd: '行末に移動。ワードラップが有効な場合、見かけ上の行末に移動',
  cursorEndSelect: '行末まで選択。ワードラップが有効な場合、見かけ上の行末まで選択',
  cursorHome: '行頭に移動。ワードラップが有効な場合、見かけ上の行頭に移動',
  cursorHomeSelect: '行頭まで選択。ワードラップが有効な場合、見かけ上の行頭まで選択',
  cursorLeft: 'カーソルを左に移動',
  cursorLeftSelect: '左に選択範囲を伸ばす',
  cursorPageDown: '1ページ下に移動',
  cursorPageDownSelect: '1ページ下に選択範囲を広げる',
  cursorPageUp: '1ページ上に移動',
  cursorPageUpSelect: '1ページ上に選択範囲を広げる',
  cursorRight: '右に移動',
  cursorRightSelect: '右に選択範囲を伸ばす',
  cursorTop: 'ファイルの先頭に移動',
  cursorTopSelect: 'ファイルの先頭まで選択範囲を広げる',
  cursorUp: '上に移動',
  cursorUpSelect: '選択範囲を上に伸ばす',
  createCursor: 'カーソルを作成（ショートカットキーで実行しても意味のないコマンドと思われる）',
  cursorLineEnd: '行末に移動',
  cursorLineStart: '行頭に移動',
  cursorWordEndLeft: '単語の終端に移動（左側）',
  cursorWordEndLeftSelect: '単語の終端まで選択範囲を拡大（左側）',
  cursorWordLeft: '単語の先頭に移動（cursorWordStartLeftと微妙に挙動が違う）',
  cursorWordLeftSelect: '単語の先頭まで選択範囲を拡大（cursorWordLeftの動きで）',
  cursorWordPartLeft: '単語の先頭、終端に移動（左方向、キャメルケースやスネークケースの単語も判別する）',
  cursorWordPartLeftSelect: '単語の先頭、終端に選択範囲を拡大（左方向、キャメルケースやスネークケースの単語も判別する）',
  cursorWordPartRight: '単語の先頭、終端に移動（右方向、キャメルケースやスネークケースの単語も判別する）',
  cursorWordPartRightSelect: '単語の先頭、終端に選択範囲を拡大（左方向、キャメルケースやスネークケースの単語も判別する）',
  cursorWordPartStartLeft: '単語の先頭に移動（キャメルケースやスネークケースの単語も判別する）',
  cursorWordPartStartLeftSelect: '単語の先頭まで選択範囲を拡大（cursorWordPartLeftの動きで）',
  cursorWordRight: '単語の終端に移動（右方向）',
  cursorWordRightSelect: '単語の終端に選択範囲を確認（右方向）',
  cursorWordStartRight: '単語の先頭に移動（右側）',
  cursorWordStartRightSelect: '単語の先頭まで選択範囲を拡大（右側）',
  deleteLeft: '左の文字を削除',
  deleteRight: '右の文字を削除',
  'editor.action.selectAll': 'すべて選択',
  expandLineSelection: '行を選択（連続で実行すると次の行に選択範囲を拡大）',
  outdent: 'アウトデント（字下げを戻す）',
  redo: 'やり直し',
  scrollLineDown: 'カーソル位置を変えずに一行下にスクロール',
  scrollLineUp: 'カーソル位置を変えずに一行上にスクロール',
  scrollPageDown: 'カーソル位置を変えずに一ページ下にスクロール',
  scrollPageUp: 'カーソル位置を変えずに一ページ上にスクロール',
  tab: 'tab',
  undo: '元に戻す',
  removeSecondaryCursors: '複数カーソルがある状態を解除',
  'repl.action.acceptSuggestion': '提案ウィジェットが出ているときにウィジェット内にフォーカスを移す',
  'actions.find': '検索',
  'actions.findWithSelection': '選択しているテキスト（あるいはカーソル位置の単語）を検索対象にする',
  'breakpointWidget.action.acceptInput': '',
  closeBreakpointWidget: '',
  closeReviewPanel: 'レビューパネルを閉じる',
  cursorUndo: '前のカーソル位置に移動（カーソルの位置履歴を一つ削除する）',
  cursorWordEndRight: '単語の終端に移動（右側）',
  cursorWordEndRightSelect: '単語の終端まで選択範囲を拡大（右側）',
  cursorWordStartLeft: '単語の先頭に移動（左側）',
  cursorWordStartLeftSelect: '単語の先頭まで選択範囲を拡大（左側）',
  deleteWordLeft: '単語の先頭・終端まで削除（左方向）',
  deleteWordRight: '単語の先頭・終端まで削除（右方向）',
  deleteAllLeft: '行頭まで削除',
  deleteAllRight: '行末まで削除',
  deleteWordEndLeft: '単語の終端まで削除（左方向）',
  deleteWordPartLeft: '単語の先頭・終端まで削除(キャメルケースやスネークケースの単語も判別する)',
  deleteWordPartRight: '単語の先頭・終端まで削除(キャメルケースやスネークケースの単語も判別する)',
  deleteWordEndRight: '単語の終端まで削除（右方向）',
  deleteWordStartLeft: '単語の先頭まで削除（左方向）',
  deleteWordStartRight: '単語の先頭まで削除（右方向）',
  'editor.action.addCommentLine': '行コメントを追加(htmlだとtoggle?)',
  'editor.action.addSelectionToNextFindMatch': '選択している文字列(もしくはハイライト)と同じ文字列を次々に選択',
  'editor.action.blockComment': 'ブロックコメントtoggle',
  'editor.action.changeAll': '現在選択しているテキストと同じテキストのすべての終端にカーソルを作成（選択しているテキストがなければカーソルのある単語）',
  'editor.action.clipboardCopyAction': 'コピー(何も選択状態でなければ行をコピー)',
  'editor.action.clipboardCutAction': 'カット(何も選択状態でなければ行をカット)',
  'editor.action.clipboardPasteAction': 'ペースト(コピーやカット時に何も選択せずコピーしていると、上に行をペースト)',
  'editor.action.commentLine': 'ラインコメントtoggle',
  'editor.action.copyLinesDownAction': '行を下に複製',
  'editor.action.copyLinesUpAction': '行を上に複製',
  'editor.action.defineKeybinding': 'keybinding.jsonを編集しているとき、設定を記述するのを助けてくれる',
  'editor.action.deleteLines': '行を削除',
  'editor.action.diffReview.next': 'gitのdiff等を見てるときに次の差分箇所に移動',
  'editor.action.diffReview.prev': 'gitのdiff等を見てるときに前の差分箇所に移動',
  'editor.action.dirtydiff.next': '次のdirtydiffを表示',
  'editor.action.dirtydiff.previous': '前のdirtydiffを表示',
  'editor.action.extensioneditor.showfind': '拡張機能閲覧時に検索窓を表示',
  'editor.action.formatDocument': '編集中ファイルを整形する',
  'editor.action.formatSelection': '選択範囲を整形する',
  'editor.action.goToDeclaration': '定義箇所に移動',
  'editor.action.goToImplementation': '',
  'editor.action.inPlaceReplace.down': '',
  'editor.action.inPlaceReplace.up': '',
  'editor.action.indentLines': 'インデント',
  'editor.action.insertCursorAbove': '上にカーソルを増やす',
  'editor.action.insertCursorAtEndOfEachLineSelected': '選択中の各行の最後にカーソルを作成',
  'editor.action.insertCursorBelow': '下にカーソルを増やす',
  'editor.action.insertLineAfter': '下に行を追加',
  'editor.action.insertLineBefore': '上に行を追加',
  'editor.action.joinLines': '現在行と下の行を繋げる',
  'editor.action.jumpToBracket': '対応するカッコにジャンプする',
  'editor.action.marker.nextInFiles': '次の警告・エラーの箇所へ',
  'editor.action.marker.prevInFiles': '前の警告・エラーの箇所へ',
  'editor.action.moveLinesDownAction': '行を下に移動させる',
  'editor.action.moveLinesUpAction': '行を上に移動させる',
  'editor.action.moveSelectionToNextFindMatch': '現在の選択箇所を検索テキストにして次の検索位置に移動(選択箇所がない場合、現在の単語を選択するのみ)',
  'editor.action.nextMatchFindAction': '次の検索位置に移動',
  'editor.action.nextSelectionMatchFindAction': '現在の選択箇所を検索テキストにして次の検索位置に移動(単語が選択されていなくても開始時に次の場所に移動)',
  'editor.action.openDeclarationToTheSide': '画面を分割して定義箇所を表示',
  'editor.action.organizeImports': '',
  'editor.action.outdentLines': 'アウトデント',
  'editor.action.peekImplementation': '',
  'editor.action.previewDeclaration': '定義箇所をプレビュー表示',
  'editor.action.previousMatchFindAction': '前の検索位置に移動',
  'editor.action.previousSelectionMatchFindAction': '現在の選択箇所を検索テキストにして前の検索位置に移動(単語が選択されていなくても開始時に前の場所に移動)',
  'editor.action.quickFix': 'クイックフィックスとリファクタリングを出す',
  'editor.action.refactor': 'リファクタリングを出す',
  'editor.action.referenceSearch.trigger': '',
  'editor.action.removeCommentLine': '行コメントを削除(htmlだとtoggle?)',
  'editor.action.rename': 'シンボルのrename',
  'editor.action.selectHighlights': 'ハイライトされているものをすべて選択',
  'editor.action.showAccessibilityHelp': '',
  'editor.action.showContextMenu': '',
  'editor.action.showHover': '',
  'editor.action.smartSelect.grow': 'スマートセレクト(拡大)',
  'editor.action.smartSelect.shrink': 'スマートセレクト(縮小)',
  'editor.action.startFindReplaceAction': '検索窓の置換メニューを開く',
  'editor.action.toggleTabFocusMode': 'タブキーでfocusが移動するモードのtoggle',
  'editor.action.toggleWordWrap': 'ワードラップ(画面端で折り返すやつ)のtoggle',
  'editor.action.triggerParameterHints': 'パラメーターヒントを表示',
  'editor.action.triggerSuggest': '',
  'editor.action.trimTrailingWhitespace': '',
  'editor.action.webvieweditor.hideFind': '検索窓を閉じる',
  'editor.action.webvieweditor.selectAll': 'すべて選択',
  'editor.action.webvieweditor.showFind': '検索窓を表示',
  'editor.action.wordHighlight.next': '',
  'editor.action.wordHighlight.prev': '',
  'editor.debug.action.showDebugHover': '',
  'editor.debug.action.toggleBreakpoint': '',
  'editor.emmet.action.expandAbbreviation': '',
  'editor.fold': 'fold',
  'editor.foldAll': 'すべてfold',
  'editor.foldAllBlockComments': 'ブロックコメントをすべてfold',
  'editor.foldAllMarkerRegions': 'すべてのMarkerRegionをfold',
  'editor.foldLevel1': '字下げの階層が1段階の部分をfold(現在カーソルがある部分はfoldされない)',
  'editor.foldLevel2': '字下げの階層が2段階の部分をfold(現以下略',
  'editor.foldLevel3': '字下げの階層が3段階の部分をfold(現以下略',
  'editor.foldLevel4': '字下げの階層が4段階の部分をfold(現以下略',
  'editor.foldLevel5': '字下げの階層が5段階の部分をfold(現以下略',
  'editor.foldLevel6': '字下げの階層が6段階の部分をfold(現以下略',
  'editor.foldLevel7': '字下げの階層が7段階の部分をfold(現以下略',
  'editor.foldRecursively': '現在の位置から下の階層の部分を各字下げ箇所でfold',
  'editor.unfold': '現在の位置でfold解除',
  'editor.unfoldAll': 'すべてfold解除',
  'editor.unfoldAllMarkerRegions': 'すべてのMarkerRegionのfoldを解除',
  'editor.unfoldRecursively': '現在の位置の下の階層をすべてfold解除',
  insertSnippet: 'スニペットの挿入',
  openReferenceToSide: '',
  'repl.action.acceptInput': '',
  'settings.action.clearSearchResults': '',
  'settings.action.editFocusedSetting': '',
  'settings.action.focusNextSetting': '',
  'settings.action.focusPreviousSetting': '',
  'settings.action.focusSettingsFile': '',
  'settings.action.search': '',
  'workbench.action.editor.nextChange': '次の差分箇所に移動',
  'workbench.action.editor.previousChange': '前の差分箇所に移動',
  closeFindWidget: '',
  'editor.action.replaceAll': 'すべて置換',
  'editor.action.replaceOne': '一つだけ置換',
  'editor.action.selectAllMatches': '検索テキストと一致するものをすべて選択',
  toggleFindCaseSensitive: '検索時に大文字と小文字を区別するかのtoggle',
  toggleFindInSelection: '検索時に選択範囲のみ検索するかのtoggle',
  toggleFindRegex: '検索時に正規表現を使用するかのtoggle',
  toggleFindWholeWord: '検索語が単語全体と一致するかのtoggle',
  jumpToNextSnippetPlaceholder: '',
  jumpToPrevSnippetPlaceholder: '',
  leaveEditorMessage: '',
  leaveSnippet: '',
  closeDirtyDiff: 'diffのプレビューを閉じる',
  closeMarkersNavigation: '',
  goToNextReferenceFromEmbeddedEditor: '',
  goToPreviousReferenceFromEmbeddedEditor: '',
  closeParameterHints: 'パラメーターヒントを閉じる',
  showNextParameterHint: '次のパラメーターヒント',
  showPrevParameterHint: '前のパラメーターヒント',
  acceptSelectedSuggestion: '選択中の提案ウィジェットを決定',
  acceptSelectedSuggestionOnEnter: '選択中の提案ウィジェットを決定',
  hideSuggestWidget: '提案ウィジェットを隠す',
  selectNextPageSuggestion: '',
  selectNextSuggestion: '',
  selectPrevPageSuggestion: '',
  selectPrevSuggestion: '',
  toggleSuggestionDetails: '',
  toggleSuggestionFocus: '',
  acceptRenameInput: '名前の変更を決定',
  cancelRenameInput: '名前の変更をキャンセル',
  'breadcrumbs.focus': 'パンくずにフォーカス',
  'breadcrumbs.focusAndSelect': 'パンくずにフォーカスして現在地を開いた状態にする',
  'breadcrumbs.focusNext': 'パンくず上で右に移動',
  'breadcrumbs.focusPrevious': 'パンくず上で左に移動',
  'breadcrumbs.revealFocused': 'パンくずを開いて現在開いているファイルの場所をフォーカスさせる',
  'breadcrumbs.revealFocusedFromTreeAside': '',
  'breadcrumbs.selectFocused': 'パンくずを開く',
  closeAccessibilityHelp: 'エディタにフォーカスを移す',
  closeReplaceInFilesWidget: '',
  copyFilePath: 'ファイルの絶対パスをコピー',
  copyRelativeFilePath: 'プロジェクト名 • ファイルの相対パス　の形でコピー',
  'debug.openBreakpointToSide': '',
  'debug.removeBreakpoint': '',
  'debug.removeWatchExpression': '',
  'editor.debug.action.toggleInlineBreakpoint': '',
  'explorer.openToSide': 'ファイルを画面を分割して開く',
  'history.showNext': '',
  'history.showPrevious': '',
  'keybindings.editor.clearSearchResults': '',
  'keybindings.editor.copyKeybindingEntry': '',
  'keybindings.editor.defineKeybinding': '',
  'keybindings.editor.focusKeybindings': '',
  'keybindings.editor.removeKeybinding': '',
  'keybindings.editor.searchKeybindings': '',
  'list.clear': '',
  'list.collapse': 'リストを閉じる',
  'list.expand': 'リストを開く',
  'list.expandSelectionDown': '',
  'list.expandSelectionUp': '',
  'list.focusDown': '下に移動',
  'list.focusFirst': '一番上に移動',
  'list.focusLast': '一番下に移動',
  'list.focusPageDown': '一ページ下に移動',
  'list.focusPageUp': '一ページ上に移動',
  'list.focusUp': '上に移動',
  'list.select': '',
  'list.selectAll': '',
  'list.toggleExpand': '',
  'notification.clear': '',
  'notification.collapse': '',
  'notification.expand': '',
  'notification.toggle': '',
  'notifications.focusFirstToast': '',
  'notifications.focusLastToast': '',
  'notifications.focusNextToast': '',
  'notifications.focusPreviousToast': '',
  'outline.focusDownHighlighted': '',
  'outline.focusUpHighlighted': '',
  'problems.action.copy': '',
  'problems.action.openToSide': '',
  revealFileInOS: '',
  'search.action.cancel': '検索を中止する',
  'search.action.copyMatch': '',
  'search.action.copyPath': 'ファイルのパスをコピー',
  'search.action.focusNextSearchResult': '次の検索結果へ',
  'search.action.focusPreviousSearchResult': '前の検索結果へ',
  'search.action.focusSearchFromResults': '検索結果にフォーカスがある時、その検索結果のファイル名にフォーカスを移動',
  'search.action.openResultToSide': '新しくエディタグループを開いて検索結果を表示',
  'search.action.remove': '検索結果から削除',
  'search.action.replace': '一つだけ置換',
  'search.action.replaceAll': 'すべて置換',
  'search.action.replaceAllInFile': 'ファイル内すべて置換',
  'search.action.replaceAllInFolder': 'フォルダ内すべて置換',
  'search.action.clearHistory': '検索履歴をclear',
  'search.action.clearSearchResults': '検索結果をclear',
  'search.action.collapseSearchResults': '検索結果をすべてたたむ',
  'search.action.copyAll': '',
  'search.action.focusSearchList': '',
  'search.action.refreshSearchResults': '',
  'search.action.toggleSearchViewPosition': '',
  'search.focus.nextInputBox': 'inputBoxで下のinputBoxに移動',
  'search.focus.previousInputBox': 'inputBoxで上のinputBoxに移動',
  'settings.action.focusSettingsFromSearch': '',
  'settings.action.focusSettingsList': '',
  'settings.action.showContextMenu': '',
  toggleSearchCaseSensitive: '検索時に大文字と小文字を区別するかのtoggle',
  toggleSearchRegex: '検索時に正規表現を使用するかのtoggle',
  toggleSearchWholeWord: '検索語が単語全体と一致するかのtoggle',
  'update.showCurrentReleaseNotes': 'Release Notesを開く',
  'workbench.action.closeActiveEditor': '現在開いているエディタを閉じる',
  'workbench.action.closeAllEditors': 'すべてのエディタを閉じる',
  'workbench.action.closeAllGroups': 'すべてのエディタグループを閉じる',
  'workbench.action.closeEditorsInGroup': 'グループ内のすべてのエディタを閉じる',
  'workbench.action.closeFolder': 'フォルダーを閉じる(ウィンドウは閉じない)',
  'workbench.action.closeGroup': 'グループを閉じる',
  'workbench.action.closeQuickOpen': 'クイックオープンを閉じる',
  'workbench.action.closeUnmodifiedEditors': '保存済みのファイルを閉じる',
  'workbench.action.closeWindow': 'ウィンドウを閉じる',
  'workbench.action.compareEditor.nextChange': '',
  'workbench.action.compareEditor.previousChange': '',
  'workbench.action.debug.continue': '',
  'workbench.action.debug.pause': '',
  'workbench.action.debug.restart': '',
  'workbench.action.debug.run': '',
  'workbench.action.debug.start': '',
  'workbench.action.debug.stepOut': '',
  'workbench.action.debug.stepOver': '',
  'workbench.action.debug.stop': '',
  'workbench.action.editor.changeLanguageMode': 'ファイルの言語モードを変更',
  'workbench.action.editor.changeEncoding': 'ファイルの文字コードを変更',
  'workbench.action.files.copyPathOfActiveFile': undefined,
  'workbench.action.files.newUntitledFile': undefined,
  'workbench.action.files.openFile': 'ファイルを開く（ファイルエクスプローラーから）',
  'workbench.action.files.openFolder': 'フォルダーを開く',
  'workbench.action.addRootFolder': 'ワークスペースにフォルダーを追加',
  'workbench.action.removeRootFolder': 'ワークスペースからフォルダーを削除',
  'workbench.action.files.revealActiveFileInWindows': undefined,
  'workbench.action.files.save': '保存',
  'workbench.action.files.saveAll': 'すべて保存',
  'workbench.action.files.saveAs': '名前をつけて保存',
  'workbench.action.files.showOpenedFileInNewWindow': '開いているファイルを別ウィンドウで開く',
  'workbench.action.findInFiles': '全ファイルから検索する',
  'workbench.action.focusFirstEditorGroup': '画面分割時に1つ目の画面にフォーカス',
  'workbench.action.focusSecondEditorGroup': '画面分割時に2つ目の画面にフォーカス',
  'workbench.action.focusThirdEditorGroup': '画面分割時に3つ目の画面にフォーカス',
  'workbench.action.focusFourthEditorGroup': '画面分割時に4つ目の画面にフォーカス',
  'workbench.action.focusFifthEditorGroup': '画面分割時に5つ目の画面にフォーカス',
  'workbench.action.focusSixthEditorGroup': '画面分割時に6つ目の画面にフォーカス',
  'workbench.action.focusSeventhEditorGroup': '画面分割時に7つ目の画面にフォーカス',
  'workbench.action.focusEighthEditorGroup': '画面分割時に8つ目の画面にフォーカス',
  'workbench.action.focusAboveGroup': '画面分割時に上の画面にフォーカスを移す',
  'workbench.action.focusBelowGroup': '画面分割時に下の画面にフォーカスを移す',
  'workbench.action.focusLeftGroup': '画面分割時に左の画面にフォーカスを移す',
  'workbench.action.focusRightGroup': '画面分割時に右の画面にフォーカスを移す',
  'workbench.action.focusSideBar': 'サイドバーにフォーカスを移す',
  'workbench.action.gotoLine': '行番号入力欄を表示して、指定された行に移動',
  'workbench.action.gotoSymbol': undefined,
  'workbench.action.hideInterfaceOverview': '',
  'workbench.action.interactivePlayground.arrowDown': '',
  'workbench.action.interactivePlayground.arrowUp': '',
  'workbench.action.interactivePlayground.pageDown': '',
  'workbench.action.interactivePlayground.pageUp': '',
  'workbench.action.keepEditor': undefined,
  'workbench.action.keybindingsReference': undefined,
  'workbench.action.lastEditorInGroup': undefined,
  'workbench.action.moveActiveEditorGroupDown': undefined,
  'workbench.action.moveActiveEditorGroupLeft': undefined,
  'workbench.action.moveActiveEditorGroupRight': undefined,
  'workbench.action.moveActiveEditorGroupUp': undefined,
  'workbench.action.moveEditorLeftInGroup': undefined,
  'workbench.action.moveEditorRightInGroup': undefined,
  'workbench.action.moveEditorToFirstGroup': undefined,
  'workbench.action.moveEditorToLastGroup': undefined,
  'workbench.action.moveEditorToNextGroup': undefined,
  'workbench.action.moveEditorToPreviousGroup': undefined,
  'workbench.action.navigateBack': '前のカーソル位置へ',
  'workbench.action.navigateForward': '次のカーソル位置へ',
  'workbench.action.navigateToLastEditLocation': '最後の編集位置に移動',
  'workbench.action.newWindow': '新しいウィンドウを開く',
  'workbench.action.switchWindow': 'ウィンドウを切り替える',
  'workbench.action.nextEditor': '次のエディタにフォーカス',
  'workbench.action.previousEditor': '前のエディタにフォーカス',
  'workbench.action.openEditorAtIndex1': '1つ目のエディタにフォーカス',
  'workbench.action.openEditorAtIndex2': '2つ目のエディタにフォーカス',
  'workbench.action.openEditorAtIndex3': '3つ目のエディタにフォーカス',
  'workbench.action.openEditorAtIndex4': '4つ目のエディタにフォーカス',
  'workbench.action.openEditorAtIndex5': '5つ目のエディタにフォーカス',
  'workbench.action.openEditorAtIndex6': '6つ目のエディタにフォーカス',
  'workbench.action.openEditorAtIndex7': '7つ目のエディタにフォーカス',
  'workbench.action.openEditorAtIndex8': '8つ目のエディタにフォーカス',
  'workbench.action.openEditorAtIndex9': '9つ目のエディタにフォーカス',
  'workbench.action.openGlobalKeybindings': 'キーボードショートカットを開く',
  'workbench.action.openGlobalKeybindingsFile': 'キーボードショートカットファイルを開く',
  'workbench.action.openNextRecentlyUsedEditorInGroup': '前に使ったエディタへ(グループ内)',
  'workbench.action.openPreviousRecentlyUsedEditorInGroup': '前に使ったエディタへ(グループ内)の操作で戻る',
  'workbench.action.openRecent': '最近開いたフォルダを開く',
  'workbench.action.openSettings': '設定画面を開く',
  'workbench.action.openSettingsJson': '設定ファイルを開く',
  'workbench.action.openGlobalSettings': '設定画面を開く',
  'workbench.action.openDefaultKeybindingsFile': 'デフォルトキーバインディングファイルを開く',
  'workbench.action.openWorkspace': 'ワークスペースを開く',
  'workbench.action.openWorkspaceInNewWindow': 'ワークスペースを新しいウィンドウで開く',
  'workbench.action.openWorkspaceSettings': 'ワークスペースの設定画面を開く',
  'workbench.action.openWorkspaceConfigFile': 'ワークスペースの設定ファイルを開く',
  'workbench.action.output.toggleOutput': undefined,
  'workbench.action.quickOpen': 'ファイルのquickOpenを開く',
  'workbench.action.quickOpenView': 'いろいろなものを開くためのビューを開く',
  'workbench.action.reopenClosedEditor': '閉じたエディタを再度開く',
  'workbench.action.replaceInFiles': undefined,
  'workbench.action.search.toggleQueryDetails': '',
  'workbench.action.selectTheme': undefined,
  'workbench.action.showAllEditors': undefined,
  'workbench.action.showAllSymbols': undefined,
  'workbench.action.showCommands': 'コマンドパレットを開く',
  'workbench.action.splitEditor': 'エディタを左右に分割',
  'workbench.action.splitEditorOrthogonal': 'エディタを上下に分割',
  'workbench.action.splitEditorDown': 'エディタを下に分割',
  'workbench.action.splitEditorLeft': 'エディタを左に分割',
  'workbench.action.splitEditorRight': 'エディタを右に分割',
  'workbench.action.splitEditorUp': 'エディタを上に分割',
  'workbench.action.tasks.build': undefined,
  'workbench.action.terminal.clear': '現在のターミナルに表示されている内容を削除',
  'workbench.action.terminal.clearSelection': '選択状態解除',
  'workbench.action.terminal.copySelection': 'コピー',
  'workbench.action.terminal.deleteToLineStart': '行頭まで削除',
  'workbench.action.terminal.deleteWordLeft': '単語の先頭まで削除',
  'workbench.action.terminal.deleteWordRight': '単語の終端まで削除',
  'workbench.action.terminal.findNext': '次の検索テキストへ',
  'workbench.action.terminal.findNextTerminalFocus': '次の検索テキストへ',
  'workbench.action.terminal.findPrevious': '前の検索テキストへ',
  'workbench.action.terminal.findPreviousTerminalFocus': '前の検索テキストへ',
  'workbench.action.terminal.focusFindWidget': '検索窓にフォーカス',
  'workbench.action.terminal.focusNextPane': '次のpaneへ',
  'workbench.action.terminal.focusPreviousPane': '前のpaneへ',
  'workbench.action.terminal.hideFindWidget': '検索窓を閉じる',
  'workbench.action.terminal.new': '新しくターミナルを開く',
  'workbench.action.terminal.openNativeConsole': 'ネイティブコンソールを開く',
  'workbench.action.terminal.paste': 'ペースト',
  'workbench.action.terminal.scrollDown': '下にスクロール',
  'workbench.action.terminal.scrollDownPage': '1ページ下にスクロール',
  'workbench.action.terminal.scrollToBottom': '最下部までスクロール',
  'workbench.action.terminal.scrollToTop': '最上部までスクロール',
  'workbench.action.terminal.scrollUp': '上にスクロール',
  'workbench.action.terminal.scrollUpPage': '１ページ上にスクロール',
  'workbench.action.terminal.split': 'ターミナル分割',
  'workbench.action.terminal.splitInActiveWorkspace': 'ターミナル分割（アクティブなフォルダで開かれる）',
  'workbench.action.terminal.toggleTerminal': 'ターミナルのtoggle',
  'workbench.action.terminal.allowWorkspaceShell': 'ワークスペースのshellの設定を有効化',
  'workbench.action.terminal.disallowWorkspaceShell': 'ワークスペースのshellの設定を無効化',
  'workbench.action.terminal.focus': 'ターミナルにfocus',
  'workbench.action.terminal.focusAtIndex1': '1つ目のターミナルにfocus',
  'workbench.action.terminal.focusAtIndex2': '2つ目のターミナルにfocus',
  'workbench.action.terminal.focusAtIndex3': '3つ目のターミナルにfocus',
  'workbench.action.terminal.focusAtIndex4': '4つ目のターミナルにfocus',
  'workbench.action.terminal.focusAtIndex5': '5つ目のターミナルにfocus',
  'workbench.action.terminal.focusAtIndex6': '6つ目のターミナルにfocus',
  'workbench.action.terminal.focusAtIndex7': '7つ目のターミナルにfocus',
  'workbench.action.terminal.focusAtIndex8': '8つ目のターミナルにfocus',
  'workbench.action.terminal.focusAtIndex9': '9つ目のターミナルにfocus',
  'workbench.action.terminal.focusNext': '前のターミナルへ',
  'workbench.action.terminal.focusPrevious': '次のターミナルへ',
  'workbench.action.terminal.kill': 'ターミナルを終了',
  'workbench.action.terminal.moveToLineEnd': '行末に移動',
  'workbench.action.terminal.moveToLineStart': '行頭に移動',
  'workbench.action.terminal.newInActiveWorkspace': '現在アクティブなフォルダでターミナルを開く',
  'workbench.action.terminal.rename': 'ターミナルの名前を変更',
  'workbench.action.terminal.resizePaneDown': 'ターミナルのPaneのサイズを下に広げる（分割時）',
  'workbench.action.terminal.resizePaneLeft': 'ターミナルのPaneのサイズを左に広げる（分割時）',
  'workbench.action.terminal.resizePaneRight': 'ターミナルのPaneのサイズを右に広げる（分割時）',
  'workbench.action.terminal.resizePaneUp': 'ターミナルのPaneのサイズを上に広げる（分割時）',
  'workbench.action.terminal.runActiveFile': 'ターミナルで現在のファイルを実行。現在バグで使えないっぽい（https://github.com/Microsoft/vscode/issues/60768）',
  'workbench.action.terminal.runSelectedText': '選択中のテキストをターミナルで実行（選択テキストがない場合現在の行を実行）',
  'workbench.action.terminal.scrollToNextCommand': '次のコマンド入力までスクロール',
  'workbench.action.terminal.scrollToPreviousCommand': '前のコマンド入力までスクロール',
  'workbench.action.terminal.selectAll': 'すべて選択',
  'workbench.action.terminal.selectDefaultShell': 'デフォルトで使用するshellを選択する',
  'workbench.action.terminal.selectToNextCommand': '次のコマンド入力まで選択範囲を広める',
  'workbench.action.terminal.selectToNextLine': '次の行まで選択範囲を広める',
  'workbench.action.terminal.selectToPreviousCommand': '前のコマンド入力まで選択範囲を広める',
  'workbench.action.terminal.selectToPreviousLine': '前の行まで選択範囲を広める',
  'workbench.action.terminal.sendSequence': 'シーケンスを送る（使用例：https://qiita.com/takarake/items/fb15c64d08e5413afc7a \n https://qiita.com/abcang/items/7cc0e2d9ae552b6f27bc）',
  'workbench.action.terminal.toggleFindCaseSensitive': '検索時に大文字と小文字を区別するかのtoggle',
  'workbench.action.terminal.toggleFindCaseSensitiveTerminalFocus': '検索時に大文字と小文字を区別するかのtoggle',
  'workbench.action.terminal.toggleFindRegex': '検索時に正規表現を使用するかのtoggle',
  'workbench.action.terminal.toggleFindRegexTerminalFocus': '検索時に正規表現を使用するかのtoggle',
  'workbench.action.terminal.toggleFindWholeWord': '検索語が単語全体と一致するかのtoggle',
  'workbench.action.terminal.toggleFindWholeWordTerminalFocus': '検索語が単語全体と一致するかのtoggle',
  'workbench.action.toggleEditorGroupLayout': undefined,
  'workbench.action.toggleFullScreen': undefined,
  'workbench.action.togglePanel': undefined,
  'workbench.action.toggleMultiCursorModifier': 'クリックでマルチカーソルを作成する際どのキーを押しながらクリックするかを切り替える。windowsの場合、alt/ctrl。macの場合cmd/ctrl',
  'workbench.action.toggleSidebarVisibility': undefined,
  'workbench.action.toggleTabsVisibility': undefined,
  'workbench.action.toggleZenMode': '禅モードtoggle',
  'workbench.action.zoomIn': 'ズームイン',
  'workbench.action.zoomOut': 'ズームアウト',
  'workbench.action.zoomReset': '画面の拡大率リセット',
  'workbench.actions.view.problems': 'problemsのtoggle',
  'workbench.debug.action.toggleRepl': undefined,
  'workbench.extensions.action.showRecommendedKeymapExtensions': '推奨のkeymap変更拡張機能を開く',
  'workbench.files.action.compareWithClipboard': undefined,
  'workbench.files.action.compareWithSaved': undefined,
  'workbench.files.action.focusOpenEditorsView': 'サイドメニューのExplorerのOPEN EDITORSのところにフォーカス',
  'workbench.view.debug': 'サイドメニューのDebugにフォーカス',
  'workbench.view.explorer': 'サイドメニューのExplorerのプロジェクトのワークツリーにフォーカス',
  'workbench.view.extensions': 'サイドメニューのExtensionsにフォーカス',
  'workbench.view.scm': 'サイドメニューのSource Controlにフォーカス',
  'workbench.view.search': 'サイドメニューのSearchにフォーカス',
  'scm.acceptInput': 'コミットする',
  'breadcrumbs.selectEditor': '',
  'workbench.action.debug.stepInto': '',
  'debug.renameWatchExpression': '',
  'debug.setVariable': '',
  'debug.toggleBreakpoint': '',
  deleteFile: 'ファイルを完全に削除',
  'filesExplorer.copy': 'ファイルをコピー',
  'filesExplorer.paste': 'コピーしたファイルをペースト',
  moveFileToTrash: 'ファイルをゴミ箱に移動',
  renameFile: 'ファイル名変更',
  'explorer.newFile': '新規ファイル作成',
  'explorer.newFolder': '新規フォルダー作成',
  closeReferenceSearch: '',
  goToNextReference: '',
  goToPreviousReference: '',
  'notifications.hideList': '',
  'notifications.hideToasts': '',
  'workbench.action.quickInputBack': '',
  'workbench.action.quickOpenNavigateNextInEditorPicker': 'エディタのquickOpenで次へ',
  'workbench.action.quickOpenNavigateNextInFilePicker': 'ファイルのquickOpenで次へ',
  'workbench.action.quickOpenNavigateNextInRecentFilesPicker': '最近開いたファイルのquickOpenで次へ',
  'workbench.action.quickOpenNavigateNextInViewPicker': 'ViewのquickOpenで次へ',
  'workbench.action.quickOpenNavigatePreviousInEditorPicker': 'エディタのquickOpenで前へ',
  'workbench.action.quickOpenNavigatePreviousInFilePicker': 'ファイルのquickOpenで前へ',
  'workbench.action.quickOpenNavigatePreviousInRecentFilesPicker': '最近開いたファイルのquickOpenで前へ',
  'workbench.action.quickOpenNavigatePreviousInViewPicker': 'ViewのquickOpenで前へ',
  'extension.node-debug.pickLoadedScript': '',
  'npm-script.showOutput': undefined,
  'uiflow.openPreviewSideBySide': 'uiflowのプレビューを表示',
  'bookmarks.toggle': 'ブックマークをtoggle',
  'bookmarks.jumpToNext': '次のブックマークにジャンプ',
  'bookmarks.jumpToPrevious': '前のプックマークにジャンプ ',
  'bookmarks.shrinkSelection': '',
  'bookmarks.expandSelectionToNext': '',
  'bookmarks.expandSelectionToPrevious': '',
  'bookmarks.clear': '現在のエディタからブックマークを削除',
  'bookmarks.clearFromAllFiles': 'すべてのエディタからブックマークを削除',
  'bookmarks.clearFromFile': '現在(2018/10/22)残っているが機能しないコマンド(?)',
  'bookmarks.deleteBookmark': '現在(2018/10/22)残っているが機能しないコマンド(?)',
  'bookmarks.jumpTo': '',
  'bookmarks.list': 'ブックマークのリストを出す',
  'bookmarks.listFromAllFiles': '',
  'bookmarks.refresh': '',
  'bookmarks.selectLines': '',
  'bookmarks.toggleLabeled': '',
  'bookmarksExplorer.focus': '',

  'npm-script.run': undefined,
  'uiflow.exportSVG': undefined,
  'npm-script.rerun-last-script': undefined,
  'uiflow.openExport': undefined,
  'npm-script.terminate-script': undefined,
  'npm-script.test': undefined,
  'markdown.showPreview': 'マークダウンプレビューを表示',
  'markdown.showPreviewToSide': '画面を分割してマークダウンプレビューを表示',
  'markdown.extension.editing.toggleBold': '',
  'markdown.extension.editing.toggleStrikethrough': '',
  'markdown.extension.editing.toggleItalic': '',
  'markdown.extension.editing.toggleHeadingUp': '',
  'markdown.extension.editing.toggleHeadingDown': '',
  'markdown.extension.editing.toggleMath': '',
  'markdown.extension.onEnterKey': '',
  'markdown.extension.onCtrlEnterKey': '',
  'markdown.extension.onShiftEnterKey': '',
  'markdown.extension.onTabKey': '',
  'markdown.extension.onShiftTabKey': '',
  'markdown.extension.onBackspaceKey': '',
  'markdown.extension.onMoveLineUp': '',
  'markdown.extension.onMoveLineDown': '',
  'markdown.extension.onCopyLineUp': '',
  'markdown.extension.onCopyLineDown': '',
  'markdown.extension.onIndentLines': '',
  'markdown.extension.onOutdentLines': '',
  'markdown.extension.checkTaskList': '',
  'markdown.extension.togglePreview': '',
  'markdown.extension.togglePreviewToSide': ''
}
